import { render, staticRenderFns } from "./SelfInviteConfirmModal.vue?vue&type=template&id=59cc88ae"
import script from "./SelfInviteConfirmModal.vue.ts?vue&type=script&lang=ts&external"
export * from "./SelfInviteConfirmModal.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports